import LocalStorageFunc from "../../helpers/localStorageFunc";
import Utility from "../../helpers/utility";

export default {
  namespaced: true,
  state: {
    edvItems: [],
    edvMaxQuantity: 2,
    edvPopUpVisible: false,
    edvCategoryClickedInfo: {},
  },
  getters: {
    getEdvItemQuantity: (state) => (product) => {
      return state.edvItems
        .filter((_) => {
          return _.id === product.id || +_.product?.id === +product.id;
        })
        .reduce((acc, edvItem) => {
          return edvItem.quantity + acc;
        }, 0);
    },
    getEdvItemLatest: (state) => (productid) => {
      for (let i = state.edvItems.length - 1; i >= 0; i--) {
        if (state.edvItems[i].id == productid) {
          return state.edvItems[i];
        }
      }
      return;
    },
  },
  mutations: {
    addToEdvItems(state, product) {
      const pizzaPosition = state.edvItems.length + 1;
      state.edvItems.push({ ...product, quantity: 1 });
      LocalStorageFunc.updateEdvItems(state.edvItems);
    },
    removeFromEdvItems(state, product) {
      const index = [...state.edvItems]
        .reverse()
        .findIndex((i) => Number(i.id) === Number(product.id));
    
      if (index !== -1) {
        const originalIndex = state.edvItems.length - 1 - index;
        state.edvItems.splice(originalIndex, 1);
      }
      LocalStorageFunc.updateEdvItems(state.edvItems);
    },
    updateEdvItem(state, product) {
      state.edvItems.push({ ...product[0], quantity: 1});
      LocalStorageFunc.updateEdvItems(state.edvItems);
    },
    updateEdvItemsFromLocalStorage(state) {
      const edvItems = LocalStorageFunc.getEdvItems();
      state.edvItems = edvItems;
    },
    emptyEdvItems(state) {
      state.edvItems = [];
      state.edvCategoryClickedInfo = {};
      LocalStorageFunc.updateEdvItems(state.edvItems);
    },
    updateEdvMaxQuantity(state, data) {
      state.edvMaxQuantity = data;
    },
    updateEdvPopUpState(state, flag) {
      state.edvPopUpVisible = flag;
    },
    addEdvItemsToCart(state) {
      if(Number(state.edvItems.length) === Number(state.edvMaxQuantity)){
        const timestamp = Utility.getUTCMilliseconds();
        state.edvItems = state.edvItems.map((item) => ({
          ...item,
          explicitPromo: {
              id: item.dealId,
              promoGroupid: timestamp,
              promoType: 'DEAL_EXPLICIT',
          },
        }));
        const cartItems = LocalStorageFunc.cart();
        const updatedCartItems = [...cartItems, ...state.edvItems];
        LocalStorageFunc.updateCart(updatedCartItems);
        state.edvItems = [];
        LocalStorageFunc.updateEdvItems([]);
      }
    },
    updateEdvCategoryClickedInfo(state, edvCategoryInfo) {
      state.edvCategoryClickedInfo = edvCategoryInfo;
    }
  },
  actions: {}
}